import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Table,
  Col,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
// import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import { ExportToExcel } from "../../Common/ExportToExcel";
import { getPOItemreportslist } from "../../../store/Reports/actions";
import "../reports.scss";

var date = new Date(),
  y = date.getFullYear(),
  m = date.getMonth();
class SRPOItemReportList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { vendor, ...otherParams } = this.props.params;
    this.props.getPOItemreportslist({
      ...otherParams,
      start_date:
        this.props.params.start_date == null ||
        this.props.params.start_date === ""
          ? moment(new Date(y, m, 1)).format("YYYY-MM-DD")
          : this.props.params.start_date,
      end_date:
        this.props.params.end_date == null || this.props.params.end_date === ""
          ? moment(new Date()).add(1, "days").format("YYYY-MM-DD")
          : moment(this.props.params.end_date)
              .add(1, "days")
              .format("YYYY-MM-DD"),
      purchaseorder__requestforquotation:
        this.props.params.requestforquotation != null
          ? this.props.params.requestforquotation
          : null,
      purchaseorder__vendor:
        this.props.params.vendor != null ? this.props.params.vendor : null,
    });
  }


  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom no-print">
                    <Link
                      to="/poreport"
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                    </Link>
                    <div className="float-right">
                      <div className="d-inline-block ">
                        <ExportToExcel
                          apiData={this.props.PO_ItemReportData.map(
                            (poItem, key) => {
                              return {
                                "S.No.": key + 1,
                                "PO Date": moment(
                                  poItem.purchaseorder.createdon
                                ).format("DD-MM-YYYY"),
                                "PO Code": poItem.purchaseorder.code,
                                "RFQ Code":
                                  poItem.purchaseorder.requestforquotation_code,

                                "Vendor Name": poItem.purchaseorder.vendor.name,
                                "Item Name": poItem.product.name,
                                "Req Qty": poItem.originalqty,
                                "Recd Qty":
                                  parseInt(poItem.originalqty) -
                                  parseInt(poItem.availableqty),
                                "Balance Qty": poItem.availableqty,
                                Rate: poItem.price,
                                "Amount(Rs)": poItem.gross,
                                "No of Days of PO": parseInt(
                                  (new Date() -
                                    new Date(poItem.purchaseorder.createdon)) /
                                    (1000 * 60 * 60 * 24)
                                ),
                              };
                            }
                          )}
                          topHeader={[
                            "SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD",
                            "Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist. - AP",
                            "Phone No.0884-2326661, 62, Mobile No.9494127893, Email: purchase@sleipl.com, lalitharice@gmail.com",
                            "",
                            "PENDING STATUS OF SERVIE ORDER REPORT",
                            "",
                          ]}
                          fileName="PENDING_STATUS_OF_PURCHASE_ORDER_REPORT"
                        />
                        {/* <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" mr-2"
                          onClick={() => this.getExcelReport()}
                        >
                          <i className="ri-file-excel-2-line"></i>
                          <span className="d-none d-inline-block ml-1">
                            Excel
                          </span>
                        </Button> */}
                        {/* <ReactHTMLTableToExcel
                          id="test-table-xls-button"
                          className=" mr-2"
                          // className="download-table-xls-button"
                          table="table-to-xls"
                          filename="tablexls"
                          sheet="tablexls"
                          buttonText="Excel"
                        /> */}
                        <Button
                          type="button"
                          outline
                          color="secondary"
                          className=" ml-2"
                          onClick={() => window.print()}
                        >
                          <i className="mdi  mdi-printer"></i>
                          <span className="d-none d-inline-block ml-1">
                            Print
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2 card-body printme">
                    <div className="text-center">
                      <span className="display_none printme">
                        <h5 className="card-title-18 pt-2 ">
                          SRI LALITHA ENTERPRISES INDUSTRIES PVT. LTD
                        </h5>
                        <p className="card-title-14 pt-2 mb-0">
                          Valuthimmapuram Road, PEDDAPURAM - 533437, E.G. Dist.
                          - AP
                        </p>
                        <p className="card-title-14 pt-2">
                          Phone No.0884-2326661, 62, Mobile No.9494127893,
                          Email: purchase@sleipl.com, lalitharice@gmail.com
                        </p>
                        <hr />
                      </span>
                      <h5 className="card-title-16 pt-3 ">
                        PENDING STATUS OF SERVICE ORDER REPORT ({" "}
                        {moment(
                          this.props.params.start_date == null ||
                            this.props.params.start_date === ""
                            ? new Date(y, m, 1)
                            : this.props.params.start_date
                        ).format("DD-MM-YYYY")}{" "}
                        TO{" "}
                        {moment(
                          this.props.params.end_date == null ||
                            this.props.params.end_date === ""
                            ? new Date()
                            : this.props.params.end_date
                        ).format("DD-MM-YYYY")}{" "}
                        )
                      </h5>
                    </div>

                    <div className="table-responsive m-0">
                      <Table
                        bordered
                        hover
                        className="mb-0 p-0 table-centered"
                        id="table-to-xls"
                      >
                        <thead className="bg-light text-center ">
                          <tr className="bg-light">
                            <th style={{ width: "2%" }}>
                              <b>S.No.</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>PO Date</b>
                            </th>
                            <th style={{ width: "8%" }}>
                              <b>PO Code</b>
                            </th>
                            <th style={{ width: "8%" }}>
                              <b>RFQ Code</b>
                            </th>

                            <th style={{ width: "15%" }}>
                              <b>Vendor Name</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Item Name</b>
                            </th>
                            <th style={{ width: "6%" }}>
                              <b>Req Qty</b>
                            </th>
                            <th style={{ width: "6%" }}>
                              <b>Recd Qty</b>
                            </th>
                            <th style={{ width: "5%" }}>
                              <b>Balance Qty</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Rate</b>
                            </th>
                            <th style={{ width: "10%" }}>
                              <b>Amount(Rs)</b>
                            </th>
                            <th style={{ width: "5%" }}>
                              <b>No of Days of PO</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.loading ? (
                            <>
                              <tr>
                                <td colSpan="12" className="text-center">
                                  <Spinner color="primary" />
                                </td>
                              </tr>
                            </>
                          ) : (
                            <>
                              {this.props.PO_ItemReportData.length !== 0 ? (
                                <>
                                  {this.props.PO_ItemReportData.map(
                                    (poItem, key) => (
                                      <>
                                        <tr key={key} className="text-center">
                                          <td>{key + 1}</td>
                                          <td>
                                            {moment(
                                              poItem.purchaseorder.createdon
                                            ).format("DD-MM-YYYY")}
                                          </td>
                                          <td>{poItem.purchaseorder.code}</td>
                                          <td>
                                            {
                                              poItem.purchaseorder
                                                .requestforquotation_code
                                            }
                                          </td>
                                          <td>
                                            {poItem.purchaseorder.vendor.name}
                                          </td>
                                          <td>{poItem.product.name}</td>
                                          <td>{poItem.originalqty}</td>
                                          <td>
                                            {parseInt(poItem.originalqty) -
                                              parseInt(poItem.availableqty)}
                                          </td>
                                          <td>{poItem.availableqty}</td>
                                          <td>{poItem.price}</td>
                                          <td>{poItem.gross}</td>

                                          <td>
                                            {parseInt(
                                              (new Date() -
                                                new Date(
                                                  poItem.purchaseorder.createdon
                                                )) /
                                                (1000 * 60 * 60 * 24)
                                            )}
                                          </td>
                                        </tr>
                                      </>
                                    )
                                  )}
                                </>
                              ) : (
                                <tr>
                                  <td colSpan="12" className="text-center">
                                    <span className="font-size-18 text-danger">
                                      Data not available
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { params, reportType, Reportdata, PO_ItemReportData, loading } =
    state.reports;
  return {
    params,
    reportType,
    Reportdata,
    PO_ItemReportData,
    loading,
  };
};

export default connect(mapStatetoProps, {
  getPOItemreportslist,
})(SRPOItemReportList);
